export default "__VITE_ASSET__71cff198__"